import Router from 'koa-router'

export const internalBoardViewRouter = new Router()

function parseQuery(query) {
  for (const key in query) {
    if (query.hasOwnProperty(key)) {
      try {
        query[key] = JSON.parse(query[key])
      } catch (error) {
        // do nothing
      }
    }
  }

  return query
}

// should be used only for building label command by headless chrome internally
internalBoardViewRouter.post('/internal-label-command-view', async (context, next) => {
  let model = context.request.body
  let data = context.query

  await context.render('internal-label-command-view', { model, data })
})

// should be used only for building board service by headless chrome internally
internalBoardViewRouter.post('/internal-board-service-view', async (context, next) => {
  let { id, model, base } = context.request.body
  const data = parseQuery({ ...context.query })

  await context.render('internal-board-service-view', { id, model, data, base })
})
